/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ContractInvoicingModeResource } from './';
import {
    ContractInvoicingModeResourceFromJSON,
    ContractInvoicingModeResourceFromJSONTyped,
    ContractInvoicingModeResourceToJSON,
} from './';
import type { InvoicingMode } from './';
import {
    InvoicingModeFromJSON,
    InvoicingModeFromJSONTyped,
    InvoicingModeToJSON,
} from './';
import type { ProjectTermsResource } from './';
import {
    ProjectTermsResourceFromJSON,
    ProjectTermsResourceFromJSONTyped,
    ProjectTermsResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContractTripartiteModeResource
 */
export interface ContractTripartiteModeResource extends ContractInvoicingModeResource {
    /**
     * 
     * @type {ProjectTermsResource}
     * @memberof ContractTripartiteModeResource
     */
    projectTerms?: ProjectTermsResource;
}

/**
 * Check if a given object implements the ContractTripartiteModeResource interface.
 */
export function instanceOfContractTripartiteModeResource(value: object): value is ContractTripartiteModeResource {
    return true;
}

export function ContractTripartiteModeResourceFromJSON(json: any): ContractTripartiteModeResource {
    return ContractTripartiteModeResourceFromJSONTyped(json, false);
}

export function ContractTripartiteModeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractTripartiteModeResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ContractInvoicingModeResourceFromJSONTyped(json, ignoreDiscriminator),
        'projectTerms': json['projectTerms'] == null ? undefined : ProjectTermsResourceFromJSON(json['projectTerms']),
    };
}

export function ContractTripartiteModeResourceToJSON(value?: ContractTripartiteModeResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ContractInvoicingModeResourceToJSON(value, true),
        'projectTerms': ProjectTermsResourceToJSON(value['projectTerms']),
    };
}

